import { NgModule } from '@angular/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DutyEditFormComponent } from 'src/app/duty-logs/components/duty-edit-form/duty-edit-form.component';
import { DutyEditPageComponent } from 'src/app/duty-logs/components/duty-edit-page/duty-edit-page.component';
import { DutyHistoryComponent } from 'src/app/duty-logs/components/duty-history/duty-history.component';
import { DutyOffFormComponent } from 'src/app/duty-logs/components/duty-off-form/duty-off-form.component';
import { DutyOffPageComponent } from 'src/app/duty-logs/components/duty-off-page/duty-off-page.component';
import { DutyOnFormComponent } from 'src/app/duty-logs/components/duty-on-form/duty-on-form.component';
import { DutyOnPageComponent } from 'src/app/duty-logs/components/duty-on-page/duty-on-page.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DutyEditRetroPageComponent } from './components/duty-edit-retro-page/duty-edit-retro-page.component';
import { DutyLogIndexPageComponent } from './components/duty-log-index-page/duty-log-index-page.component';

@NgModule({
  imports: [SharedModule, InputsModule],
  declarations: [
    DutyLogIndexPageComponent,
    DutyOnPageComponent,
    DutyOnFormComponent,
    DutyOffPageComponent,
    DutyEditPageComponent,
    DutyOffFormComponent,
    DutyEditFormComponent,
    DutyHistoryComponent,
    DutyEditRetroPageComponent,
  ],
})
export class DutyLogsModule {}
